// After a deploy, open tabs still reference the previous build's chunk files,
// which no longer exist on the server. A plain reload picks up the new build.
const RELOAD_AT_KEY = 'chunkReloadAt'
// A chunk that still fails within this window after a reload is a real failure,
// not a stale build, so don't reload again (prevents reload loops)
const RELOAD_GUARD_MS = 60 * 1000

let isReloading = false

export const isChunkLoadError = (error) =>
  error?.name === 'ChunkLoadError' ||
  /Loading (CSS )?chunk .+ failed/i.test(error?.message || '')

// Returns true if a reload was started, false if it was skipped
export const reloadForChunkError = () => {
  if (isReloading) return true
  if (navigator?.onLine === false) return false
  try {
    const lastReloadAt = Number(sessionStorage.getItem(RELOAD_AT_KEY))
    if (lastReloadAt && Date.now() - lastReloadAt < RELOAD_GUARD_MS) {
      console.error('Chunk still failing after reload.')
      return false
    }
    sessionStorage.setItem(RELOAD_AT_KEY, String(Date.now()))
  } catch {
    // Without sessionStorage there's no loop guard, so don't reload
    return false
  }
  isReloading = true
  window.location.reload()
  return true
}
